<template>
	<modal ref="modal" size="modal-xl">
		<template #title>Sign In Logs</template>
		<template #body>
			<div v-if="signInLogs.length > 0" class="table-responsive">
				<table
					class="table table-striped table-borderless table-hover table-vcenter"
				>
					<thead>
						<tr>
							<th>Date & Time</th>
							<th>Description</th>
							<th>IP Address</th>
						</tr>
					</thead>
					<tbody class="fs-sm">
						<tr v-for="signInLog in signInLogs" :key="signInLog.id">
							<td>{{ signInLog.date_signin }}</td>
							<td>{{ signInLog.description }}</td>
							<td>{{ signInLog.ip_address }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else class="alert alert-warning">
				<p class="mb-0">NO SIGN-IN LOGS FOUND</p>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'

export default {
	props: {
		signInLogs: Object,
	},
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		return {
			modal,
			toggleModal,
		}
	},
}
</script>
